// extracted by mini-css-extract-plugin
export default {"schoolLogoWrapper":"SpecialReportImage_schoolLogoWrapper__imu8d","buttonsWrapper":"SpecialReportImage_buttonsWrapper__l+T77","logoWrapper":"SpecialReportImage_logoWrapper__lXU7W"};